import { render, staticRenderFns } from "./location-cascader.vue?vue&type=template&id=649c4808"
import script from "./location-cascader.vue?vue&type=script&lang=js"
export * from "./location-cascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports